// extracted by mini-css-extract-plugin
export var childrenContainer = "Layout-module--childrenContainer--c4154";
export var navbar = "Layout-module--navbar--9d44b";
export var navbarInnerContainer = "Layout-module--navbarInnerContainer--2ffc0";
export var side = "Layout-module--side--70a3b";
export var socialLinksContainer = "Layout-module--socialLinksContainer--c1653";